export default __webpack_public_path__ + "static/media/cdr-logo.a6c12d86.svg";